import { BackButton } from '@/components/ui/BackButton';

export type LegalBlock = { h: string } | { p: string };

/**
 * Renders a legal document (Terms / Privacy) as a flowing article: a muted
 * "last updated" line, then headings and paragraphs. Paragraphs preserve
 * newlines (whitespace-pre-line) so bullet lists render exactly as authored.
 */
export function LegalDoc({ title, meta, blocks }: { title: string; meta: string; blocks: LegalBlock[] }) {
  return (
    <div className="min-h-screen bg-surface0 text-white page-enter">
      <header className="sticky top-0 z-10 flex items-center gap-3 border-b border-white/[0.08] bg-surface0/90 px-5 py-4 backdrop-blur">
        <BackButton />
        <h1 className="text-lg font-bold">{title}</h1>
      </header>

      <article className="mx-auto w-full max-w-[720px] px-6 py-8">
        <p className="mb-6 text-[13px] text-white/40">{meta}</p>
        {blocks.map((block, i) =>
          'h' in block ? (
            <h2 key={i} className="mb-2 mt-7 text-base font-bold text-white first:mt-0">
              {block.h}
            </h2>
          ) : (
            <p key={i} className="mb-3 whitespace-pre-line text-sm leading-[1.7] text-white/55">
              {block.p}
            </p>
          ),
        )}
        <div className="h-10" />
      </article>
    </div>
  );
}
